const isSandbox = () => {
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return false;
  }

  return (
    window.location.origin.includes('sandbox') ||
    window.location.origin.includes('pga.local') ||
    window.location.origin.includes('localhost')
  );
}

const getInfoBaseUrl = () => (
  isSandbox() ? 'https://cc-www.sandboxpga.org' : 'https://pga.org'
)

/**
 * Builds a full URL for info (eg., 'Learn More') links
 * These pages are created in CloudCannon 
 * and deployed to pga.org (Prod) and cc-www.sandboxpga.org (Staging)
 * 
 * Examples:
 *   buildInfoUrl('/membership/background-checks') => 'https://pga.org/membership/background-checks'
 *   buildInfoUrl('https://pga.com/more-information') => 'https://pga.com/more-information'
 */
export const buildInfoUrl = (url) => {
  if (!url) return ''
  
  // If already a full URL, use as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url
  }
  
  // For relative paths, build full URL to info domain
  const path = url.startsWith('/') ? url : `/${url}`
  return `${getInfoBaseUrl()}${path}`
}
